import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/blockrise.webp';
import screenshot_target from '../../../images/letterfunnel/joslazet.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Jos Lazet"
      firstname="Jos"
      companyname="Blockrise"
      competition="Amdax en Bitvavo"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/joslazet.js